import { tassign } from 'tassign';
import * as _ from 'lodash';

// Own feature
import { UiMessageSnack } from '../model/message-snack.class';

import {
   // -- message snack --------------------------
   UI_MESSAGE_SNACK,
   UI_MESSAGE_SNACK_RESET
} from './actions';

export interface IUiState {
   // -- message snack --------------------------
   messageSnack: UiMessageSnack | null;

}

export const UI_INITIAL_STATE: IUiState = {
   // -- message snack --------------------------
   messageSnack: null
};

export function uiReducer(state: IUiState = UI_INITIAL_STATE, action): IUiState {
   switch (action.type) {
      // -- message snack --------------------------
      case UI_MESSAGE_SNACK: return messageSnack(state, action);
      case UI_MESSAGE_SNACK_RESET: return messageSnackReset(state, action);

      default:
        console.error('Unknown action type in Ui-Reducer', action.type);

   }
   return state;
}

// ------------------------------------------------------------------------------------------------
// -- message snack  ------------------------------------------------------------------------------
// ------------------------------------------------------------------------------------------------
function messageSnack(state, {type: type, payload: {object: obj}}) {
   return tassign(state, {
      messageSnack: obj
   });
}
function messageSnackReset(state, action) {
   return tassign(state, {
      messageSnack: null
   });
}




// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/core/components/message-snack/store/store.ts